import React from "react";

import './Footer.css';

const Footer = () => {
    return (
        <footer>
            Copyright © 2026 - Subhranil Sarkar. All rights reserved.
        </footer>
    );
}

export default Footer;